import type { TRuleWithTheme } from '@ackee/fela';

export const post: TRuleWithTheme = () => ({
    width: '100%',
    marginBottom: 80,

    textAlign: 'left',
});

export const link: TRuleWithTheme = () => ({
    textDecoration: 'none',
});

export const thumbnailWrapper: TRuleWithTheme = () => ({
    position: 'relative',
    paddingTop: '75%',
    width: '100%',
    overflow: 'hidden',

    ':hover': {
        '& .mask': {
            opacity: 0.12,
        },

        '& .thumbnail': {
            transform: 'translateX(-50%) scale(1.15)',
        },
    },
});

export const thumbnail: TRuleWithTheme = () => ({
    height: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '50%',

    transform: 'translateX(-50%)',
    transition: 'transform 0.35s ease-in-out',
});

export const thumbnailMask: TRuleWithTheme = ({ theme }) => ({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,

    opacity: 0,
    backgroundColor: theme.colors.fuchsia,

    transition: 'all 0.5s ease',
});

export const title: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    marginTop: '1.375rem',
    marginBottom: '1.5rem',
    textDecoration: 'underline solid transparent',

    ':hover': {
        color: colors.blue,
        textDecoration: `underline solid ${colors.blue}`,

        transition,
    },
});
